import React from 'react';
import { connect } from 'react-redux';
import './Filter.css'
import FilterByKeyword from '../FilterByKeyword/FilterByKeyword';
import FilterDropdown from './FilterDropdown/FilterDropdown';
import FilterByDate from './FilterByDate/FilterByDate';
import { IconButton, TooltipHost } from '@fluentui/react';
import TranslateTag from '../../../Utils/Local/TranslateTag';
import FilterPicker from './FilterPicker/FilterPicker';
import FilterNumberRanges from './FilterNumber/FilterNumberRanges';

const Filter = (props) => {

    const showSearch = props.filterSearch !== undefined ? props.filterSearch : true;
    const showDate = props.dateSearch !== undefined ? props.dateSearch : true;
    const showNumberRange = props.numberRanges !== undefined && props.numberRanges !== "";

    // Experimental hot-keys.
    document.onkeydown = function(e) {
        if (e.ctrlKey && e.key === "Backspace") {
            props.refresh();
        }
    };

    return (
        <div className="filter-content">
            <div className="filter-search">
                <div className="filter-search-item">
                    {showSearch && <div className="filter-child">
                        <FilterByKeyword searchChangeHandler={props.searchChangeHandler} language={props.language} value={props.searchText}></FilterByKeyword>
                    </div>}
                    {showDate && <div className="filter-child">
                        <FilterByDate dateChangeHandler={props.dateChangeHandler} startDate={props.startDate} endDate={props.endDate} language={props.language}></FilterByDate>
                    </div>}
                </div>
                <div className="filter-search-item">
                    {showNumberRange && <div className="filter-child">
                        <FilterNumberRanges numberRanges={props.numberRanges} language={props.language} changeHandler={props.filterChangeHandler} filters={props.filters} ></FilterNumberRanges>
                    </div>}
                </div>
            </div>
            <div className="filter-dropdowns">
                {props.filters.map((filter) => {
                        if (filter.Type === "picker") {
                            return (
                                <div className="filter-item" key={filter.Key}>
                                    <FilterPicker filter={filter} click={props.click} language={props.language}></FilterPicker>
                                </div>
                            )
                        } else {
                            return (
                                <div className="filter-item" key={filter.Key}>
                                    <FilterDropdown filter={filter} click={props.click}></FilterDropdown>
                                </div>
                            )
                        }
                })}
                <TooltipHost
                    content={TranslateTag("@GenRef@", props.language)}
                    id={901}
                >
                    <IconButton
                        id="refreshFilter"
                        iconProps={{iconName: 'Refresh'}}
                        onClick={props.refresh}
                    />
                </TooltipHost>
                <TooltipHost
                    content={TranslateTag("@GenCle@", props.language)}
                    id={902}
                >
                    <IconButton
                        id="clearFilter"
                        iconProps={{iconName: 'Cancel'}}
                        onClick={props.clear}
                    />
                </TooltipHost>
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        language: state.config.language
    };
}

export default connect(mapStateToProps)(Filter);
